import styled from "styled-components";

const StyledFooter = styled.div`
    position: fixed;
    width: 100vw;
    height: 3vh;
    top: 97vh;
    background-color: rgb(10,10,10);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 15px;
    box-sizing: border-box;
    
`

const FooterText = styled.p`
    color: white;
`

function Footer(){
    return(
        <StyledFooter>
            <FooterText>
                made with ❤️ by sapok
            </FooterText>
            <FooterText style={{textAlign: 'right'}}>
                © sapok {new Date().getFullYear()} or whatever the legal people say
            </FooterText>
        </StyledFooter>
    )
}

export default Footer;